import { useState, useEffect } from 'react';
import { getInfoByType } from 'services/info';
import { Footer, Header, Wrapper, Title, SubTitle } from 'components';
import { formattedDate } from 'helpers/formatDate';
import Info from 'services/info/models/info-interface';

import { TermsContainerWrapper, TermsOfUse } from './style';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

function Home() {
  const [term, setTerm] = useState<Array<Info>>();

  useEffect(() => {
    (async () => {
      const user = JSON.parse(localStorage.getItem('exeltis-user') as string);
      let terms;

      if (user) {
        terms = await getInfoByType('TERM');
      } else {
        const token = 'Bearer ' + process.env.REACT_APP_UNLOGGED_TOKEN;
        terms = await getInfoByType('TERM', { Authorization: token });
      }

      setTerm(terms);
    })();
  }, []);

  return (
    <TermsContainerWrapper>
      <Header reduceHeader={false} showHeaderNotLogged />

      <Wrapper>
        <Title>TERMOS DE USO</Title>

        {term && term.length ? (
          <>
            <SubTitle>
              Este Termo foi modificado pela última vez em{' '}
              {formattedDate(new Date(term[0].date))}.
            </SubTitle>

            <TermsOfUse>
              <div dangerouslySetInnerHTML={{ __html: term[0].text }} />
            </TermsOfUse>
          </>
        ) : null}
      </Wrapper>
      <Footer backgroundColor={'var(--default-background-color)'} hasLogo />
    </TermsContainerWrapper>
  );
}

export default Home;
